export default __webpack_public_path__ + "static/media/auto-parts.d00982c6.jpg";